import { lazyPipe, validateApiResponse, withApiErrorCapture } from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { campaignsApiPath } from './apiPath';

/** 제안형 4탭 카운트 — spec CountMyProposalCampaignsV2Response (camelCase) */
const GetSeedingMeProposalCountResponseDataSchema = z
  .object({
    /** 제안 탭 카운트 */
    pending: z.number().nonnegative(),
    /** 수락 탭 카운트 */
    confirmed: z.number().nonnegative(),
    /** 완료 탭 카운트 */
    completed: z.number().nonnegative(),
    /** 거절 탭 카운트 */
    rejected: z.number().nonnegative(),
  })
  .describe('GetSeedingMeProposalCountResponseDataSchema');

const GetSeedingMeProposalCountResponseSchema = createApiResponseSchema(
  GetSeedingMeProposalCountResponseDataSchema,
);

export type GetSeedingMeProposalCountResponse = z.infer<
  typeof GetSeedingMeProposalCountResponseSchema
>;

export const getSeedingMeProposalCount = withApiErrorCapture(
  lazyPipe(
    async (): Promise<GetSeedingMeProposalCountResponse> =>
      executeStandardRequest(async () => {
        const response = await privateHttpClient.get<GetSeedingMeProposalCountResponse>(
          urlJoin(campaignsApiPath.getSeedingMeProposalCount),
        );
        return response;
      }),
    validateApiResponse(GetSeedingMeProposalCountResponseSchema),
  ),
);
